import * as React from "react"
import { graphql } from "gatsby"
import { Button } from "../ui"

export type ButtonProps = {
  link: string
  text: string
  newWindow: boolean
}

export default function ButtonComponent(props: ButtonProps) {
  return (
    <div style={{ display: "flex", justifyContent: "center"}}>
      <Button to={props.link} target="_blank">
        {props.text}
      </Button>
    </div>
  )
}

export const query = graphql`
  fragment ButtonContent on Button {
    desktopRight
    link
    text
    newWindow
  }
`